<template></template>

<script setup>
import { getCurrentInstance, onMounted, onUnmounted, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { emitter } from '@/event-bus';

const store = useStore();
const echo = getCurrentInstance().appContext.config.globalProperties.$echo;

const token = store.state.auth.token;

// Use computed for reactivity on userDetails
const currentUser = computed(() => store.state.auth.userDetails);

const setConversationList = async () => {
  await store.dispatch('conversation/getAllConversations');
};

const bindChannels = () => {
  if (!currentUser.value?.participant_identifier) return;

  echo
    .private(`conversation.${currentUser.value.participant_identifier}`)
    .listen('ConversationCreated', (payload) => {
      store.commit('conversation/addConversation', payload);
    })
    .listen('ConversationMessageCreated', (payload) => {
      store.commit('conversation/addMessage', payload.message);
      store.commit('conversation/addConversation', payload.conversation);
      emitter.emit('new-message', payload.message); // ✅ moved inside
    });
};

const disconnect = () => {
  if (currentUser.value?.participant_identifier) {
    echo.leave(`conversation.${currentUser.value.participant_identifier}`);
  }
};

const checkConnection = () => {
  const isConnected = echo.connector?.pusher?.connection?.state === 'connected';
  emitter.emit('broadcasting:status', isConnected); // emit globally if needed
};

onMounted(async () => {
  echo.channel('chat').listen('.new-message', (payload) => {
    console.log('Received message:', payload);
  });

  if (currentUser.value) {
    await setConversationList();
    bindChannels();

    echo.connector.pusher.connection.bind('connected', checkConnection);
    echo.connector.pusher.connection.bind('disconnected', checkConnection);

    checkConnection(); // Initial status
  }
});

// Cleanup on unmount
onUnmounted(() => {
  disconnect();
});

// React to login/logout user changes
watch(
  () => currentUser.value,
  async (newUser, oldUser) => {
    if (!newUser && oldUser) {
      disconnect();
    } else if (newUser && !oldUser) {
      await setConversationList();
      bindChannels();
      checkConnection();
    }
  },
);
</script>

<style scoped></style>
